import React from 'react';

export default function WalletCard({ plane, isPreview }) {
  const imageUrl = plane?.image_url;

  // --- Preview Card State ---
  if (isPreview) {
    const previewTitle = `${plane?.manufacturer || ''} ${plane?.model || ''}`.trim();
    return (
      <div 
        className="wallet-card is-preview-card"
        style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : 'none' }}
      >
        <div className="wallet-card__preview-title">{previewTitle}</div>
      </div>
    );
  }

  // --- Full "Modern Tech Card" State with Background Image ---
  return (
    <div 
      className="wallet-card is-tech-card"
      style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : 'none' }}
    >
      {/* The overlay is now responsible for the dark gradient and content */}
      <div className="tech-card-overlay">
        <header className="card-header">
          <h3 className="card-main-title">{plane?.name || 'Airplane Name'}</h3>
        </header>

        {/* Body section is now removed to simplify the card */}

        <footer className="card-footer">
            {plane?.interesting_story && (
              <div className="story-teaser">趣闻轶事</div>
            )}
        </footer>
      </div>
    </div>
  );
}
